import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media.js';
import { StyledLabel } from '../../../../Form/Label/index.js';
import { TableCellContentType } from '../TableCell/types.js';
export const TableHeadWrapper = styled.th `
  ${({ textBold, theme }) => textBold && theme.typography.weightMedium}
  ${({ width, fluid }) => width &&
    !fluid &&
    css `
      width: ${width}px;
    `}
  ${({ fluid }) => fluid &&
    css `
      width: 100%;
    `}
  display: table-cell;
  vertical-align: middle;
  ${({ align }) => align &&
    css `
      text-align: ${align};
    `}
  min-height: 20px;
  padding: ${({ contentType, $compact }) => {
    if (contentType === TableCellContentType.CHECKBOX || contentType === TableCellContentType.ACTION) {
        return 0;
    }
    if ($compact) {
        return '8px';
    }
    return '16px 12px';
}};
  ${({ theme }) => theme.typography.textSmall};
  color: ${({ theme, order }) => (order ? theme.colors.black_1 : theme.colors.grey100_1)};
  cursor: ${({ sortable }) => (sortable ? 'pointer' : 'default')};
  white-space: nowrap;
  ${({ theme }) => theme.typography.weightDefault};

  @media ${Media.smMin} {
    ${({ contentType, $compact }) => contentType === TableCellContentType.CHECKBOX &&
    css `
        padding: 0;
        width: 1px;
        height: 1px;
        @-moz-document url-prefix() {
          height: 100%;
        }
        position: sticky;
        left: 0;
        z-index: 1;
        // Opaque on its own: in a table with groups the cell gets a transparent border, through which
        // the scrolled columns would show where a browser leaves the row background behind
        background: ${({ theme }) => theme.colors.grey01_1};

        & > * {
          width: 45px;
          background: ${({ theme }) => theme.colors.grey01_1};
          border-right: 1px solid ${({ theme }) => theme.colors.grey10_1};
          padding: ${$compact ? '8px' : '16px 12px'};
          height: 100%;
        }
      `}

    ${({ contentType, $compact }) => contentType === TableCellContentType.ACTION &&
    css `
        padding: 0;
        width: 1px;
        height: 1px;
        @-moz-document url-prefix() {
          height: 100%;
        }
        position: sticky;
        right: 0;
        z-index: 1;

        & > * {
          width: 61px;
          background: ${({ theme }) => theme.colors.grey01_1};
          border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
          padding: ${$compact ? '8px' : '16px 12px'};
          height: 100%;
        }
      `}

    ${({ $sticky }) => $sticky &&
    css `
        position: sticky;
        top: 0;
        z-index: 1;
        background: ${({ theme }) => theme.colors.grey01_1};
      `}

    ${({ theme, sortable }) => sortable &&
    css `
        &:hover {
          background: ${theme.colors.grey05_1};
        }
      `}

    ${StyledLabel} {
      display: none;
    }
  }

  @media ${Media.xsMax} {
    display: block;

    ${({ contentType }) => contentType === TableCellContentType.CHECKBOX
    ? css `
            padding: 8px 12px;
          `
    : css `
            display: none;
          `}
  }
`;
